<template>
  <div id="CoursewareAdd" v-loading="loading" class="mainDiv">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      style="padding: 0 20px"
    >
      <!--      <el-form-item label="课件库信息" style="font-weight: bold;">-->
      <!--      </el-form-item>-->
      <el-form-item
        label="课件库名称："
        :required="true"
        style="display: inline-block"
      >
        <el-input
          v-model="form.name"
          v-bind:disabled="issDisabled"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="办学形式："
        :required="true"
        style="display: inline-block"
      >
        <el-checkbox-group v-model="form.type">
          <el-checkbox
            v-for="(types, index) in typeList"
            :key="typeList.typeCode"
            :label="types.typeName"
            name="type"
            v-bind:disabled="issDisabled"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="关联课程：" :required="true">
        <div>
          <div v-show="linkSelf.length > 0 ? true : false">
            <label for="" style="vertical-align: top">自学考试:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkSelf"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.courseName }},</span
              >
            </div>
          </div>
          <div v-show="linkAdult.length > 0 ? true : false">
            <label for="" style="vertical-align: top">成人教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkAdult"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.courseName }},</span
              >
            </div>
          </div>
          <div v-show="linkNet.length > 0 ? true : false">
            <label for="" style="vertical-align: top">网络教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkNet"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.courseName }},</span
              >
            </div>
          </div>
          <div v-show="linkTrain.length > 0 ? true : false">
            <label for="" style="vertical-align: top">高端培训:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkTrain"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.courseName }},</span
              >
            </div>
          </div>
        </div>
        <el-button type="primary" @click="linkCourse" v-show="isChoose"
          >请选择课程</el-button
        >
      </el-form-item>
      <el-form-item label="关联专业：">
        <div>
          <div v-show="linkSelf.length > 0 ? true : false">
            <label for="" style="vertical-align: top">自学考试:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkSelf"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.majorName }},</span
              >
            </div>
          </div>
          <div v-show="linkAdult.length > 0 ? true : false">
            <label for="" style="vertical-align: top">成人教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkAdult"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.majorName }},</span
              >
            </div>
          </div>
          <div v-show="linkNet.length > 0 ? true : false">
            <label for="" style="vertical-align: top">网络教育:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkNet"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.majorName }},</span
              >
            </div>
          </div>
          <div v-show="linkTrain.length > 0 ? true : false">
            <label for="" style="vertical-align: top">高端培训:</label>
            <div style="display: inline-block; width: 80%; margin-left: 10px">
              <span
                v-for="(item, index) in linkTrain"
                :key="index"
                style="margin-right: 5px"
                >{{ item.zkolBaseCourseVO.majorName }},</span
              >
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="创建机构："
        :required="true"
        style="display: inline-block"
      >
        <el-input
          v-model="form.organization"
          v-bind:disabled="issDisabled"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="创建人："
        :required="true"
        style="display: inline-block"
      >
        <el-input
          v-model="form.user"
          v-bind:disabled="issDisabled"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item style="text-align: center; padding: 30px 0">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button type="primary" @click="changeDes">修 改</el-button>
<!--        <el-button type="primary" @click="kjManager">课件管理</el-button>-->
      </el-form-item>
    </el-form>
    <Courseware-review-edit
      v-if="isShowDialog"
      ref="CoursewareReviewEdit"
      @sendSelfStudy="sendSelfStudy"
      @sendAdultStudy="sendAdultStudy"
      @sendNetStudy="sendNetStudy"
      @sendTrainStudy="sendTrainStudy"
    ></Courseware-review-edit>
  </div>
</template>

<script>
import { confirmMsg } from "@/utils/common";
import * as api from "@/api/courseware/coursewareList";
import CoursewareReviewEdit from "./Courseware-edit";
export default {
  name: "CoursewareAdd",
  components: {
    CoursewareReviewEdit,
  },
  data() {
    return {
      typeList: [],
      isChoose: false,
      issDisabled: true,
      loading: false,
      form: {
        name: "",
        type: [],
        organization: "",
        user: "",
      },
      isShowDialog: false,
      linkSelf: [],
      linkAdult: [],
      linkNet: [],
      linkTrain: [],
    };
  },
  methods: {
    changeDes() {
      this.isChoose = true;
      this.issDisabled = false;
    },

    // 获取数据
    getList() {
      // this.loading = true
      api.viewCourseWare(this.$route.params.id).then(({ data }) => {
        data = data.data;
        console.log(data);
        this.form.name = data.wareName;
        this.form.user = data.uname;
        this.form.organization = data.institutionName;
        for (let i = 0; i < data.zkolCoursewareLearntypeRefs.length; i++) {
          this.form.type.push(
            data.zkolCoursewareLearntypeRefs[i].zkolBaseDictTypeVO.typeName
          );
        }
        let linkData = data.zkolCourseCoursewareRefs;
        for (let i = 0; i < linkData.length; i++) {
          if (linkData[i].zkolBaseCourseVO.educationTypeName == "自学考试") {
            this.linkSelf.push(linkData[i]);
          } else if (
            linkData[i].zkolBaseCourseVO.educationTypeName == "成人教育"
          ) {
            this.linkAdult.push(linkData[i]);
          } else if (
            linkData[i].zkolBaseCourseVO.educationTypeName == "网络教育"
          ) {
            this.linkNet.push(linkData[i]);
          } else if (
            linkData[i].zkolBaseCourseVO.educationTypeName == "高端培训"
          ) {
            this.linkTrain.push(linkData[i]);
          }
        }
        this.loading = false;
      });
    },

    getEducationType() {
      api.getEducationType().then(({ data }) => {
        data = data.data;
        this.typeList = data;
      });
    },

    //确定
    onSubmit() {
      const url = "CoursewareList";
      this.$emit("set-active-from-sub", url);
      this.$router.push(url);
    },

    kjManager() {
      this.$router.push({
        name: "CheckCourseware", //tab所在的页面
        query: {
          type: "third",
        },
      });
      this.$router.go(0); //刷新跳转到课件列表
    },

    //    点击关联课程按钮
    linkCourse() {
      this.isShowDialog = true;
      this.$nextTick(() => {
        this.$refs.CoursewareReviewEdit.init();
      });
    },
    sendSelfStudy(data) {
      this.linkSelf = data;
    },
    sendAdultStudy(data) {
      this.linkAdult = data;
    },
    sendNetStudy(data) {
      this.linkNet = data;
    },
    sendTrainStudy(data) {
      this.linkTrain = data;
    },
  },
  created() {
    this.getList();
    this.getEducationType();
  },
  computed: {
    getUId() {
      return localStorage.getItem("uid") || "36";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
